const reducePinRequest = (state) => ({ ...state, lockError: false });

// noinspection JSUnusedGlobalSymbols
export default reducePinRequest;
